export default [
  { title: "Home", text: "Home" },
  { title: "Bio", text: "Bio" },
  { title: "Order", text: "Order a Pizza"},
  { title: "Pizza", text: "See all the Pizzas" }
];
